package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class PieceJointe (
    val id: String,
    piece_jointe: String = ""
) {
  var piece_jointe by mutableStateOf(piece_jointe)

}